// hooks/useLogout.js
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearSession } from "../utils/authStorage";
import apiClient from "../API";
import { invalidateSessionCache } from "../API/_cache";

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      // Task 149: the session is an HttpOnly cookie, so this code cannot
      // remove it — only the server can. clearSession removes every identity
      // key together and notifies, so the header updates without waiting for
      // a navigation.
      clearSession();
      // Not identity, so not clearSession's business: the in-progress
      // eligibility answers a guest may have started before signing in.
      localStorage.removeItem("visaEligibilityAnswers");

      // Wipe the in-memory + sessionStorage API cache so the next user on
      // this device (or this user after a re-login as someone else) never
      // sees stale form/application data.
      invalidateSessionCache();

      // Not optional any more, and not this path either: "/api/logout" was
      // relative to the app origin and never reached the API. Signing out is
      // now the only way to clear the session cookie, so it must be awaited
      // and must address the real endpoint.
      //
      // Failures are swallowed deliberately — signing out has to appear to
      // work when the session has already expired or the network is down,
      // otherwise there is no way out of a broken session.
      try {
        await apiClient.post("/auth/logout");
      } catch {
        // Already signed out, or unreachable. Continue clearing locally.
      }

      // Optional: Show toast
      toast.success("You have been logged out!");

      // Redirect to login/home
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error("Error logging out. Please try again.");
    }
  };

  return logout;
};

export default useLogout;
